/**
 * 组件类型枚举
 * 定义活动页面支持的组件类型
 */
export enum ComponentTypeEnum {
  /** 沉浸式导航栏 - 支持标题文案、背景图配置（支持渐变色） */
  NAV_BAR = 'NavBar',
  /** 氛围背景图头部 - 支持背景图、点击事件配置，需与导航栏背景样式上下衔接 */
  ATMOSPHERIC_HEADER = 'AtmosphericHeader',
  /** 通用静态矩形组件 - 支持背景图、点击事件配置，用于"去申请"按钮、"产品介绍"等模块 */
  COMMON_STATIC_RECTANGLE = 'CommonStaticRectangle',
  /** 通用漂浮矩形组件 - 支持背景图、点击事件配置，固定定位显示 */
  COMMON_FIXED_RECTANGLE = 'CommonFixedRectangle',
}

/**
 * 自定义点击事件名称枚举
 * 定义活动页面支持的自定义点击事件名称
 */
export enum CustomClickEventNameEnum {
  /** 跳转授信 */
  JUMP_TO_CREDIT = 'jumpToCredit',
  /** 跳转我的 */
  JUMP_TO_MINE = 'jumpToMine',
  /** 跳转提现 */
  JUMP_TO_APPLY = 'jumpToApply',
   /** 自定义路由跳转 */
  JUMP_TO_ROUTE = 'jumpToRoute',
}
